import { ReactElement, useCallback } from 'react';
import { createFetchContext } from '../../../../../../components/contexts/FetchContextFactory';
import { OtherStudiesFormData } from '../../types';
import { getOtherStudiesFormData } from '../../../../api/educationalInformationRequests';
import { SelectOptionType } from '@octano/global-ui';
import { Col } from 'reactstrap';
import Loading from '../../../../../../components/info/Loading';

export interface OtherStudiesFormLoaderProps {
  children: (props: {
    academicLevels: SelectOptionType[];
    countries: SelectOptionType[];
    institutions: SelectOptionType[];
    loading: boolean;
  }) => ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  OtherStudiesFormData
>();

export function useOtherStudies() {
  return useFetch();
}

export const OtherStudiesLoaderConsumer = FetchConsumer;

export function OtherStudiesFormLoader({
  children,
}: OtherStudiesFormLoaderProps) {
  const request = useCallback(async () => {
    return getOtherStudiesFormData();
  }, []);

  return (
    <FetchProvider request={request} defaultQuery={undefined} fetchImmediately>
      <FetchConsumer>
        {({ data, loading }) => {
          if (loading) {
            return (
              <Col md={12}>
                <Loading insideCard />
              </Col>
            );
          }
          if (data) {
            return children({
              academicLevels: data.academicLevels.map((academicLevel) => ({
                label: academicLevel.name,
                value: academicLevel.id,
              })),
              countries: data.countries.map((country) => ({
                label: country.name,
                value: country.id,
              })),
              institutions: data.institutions.map((institution) => ({
                label: institution.code
                  ? `(${institution.code}) - ${institution.name}`
                  : institution.name,
                value: institution.id,
                code: institution.code,
                countryId: institution.countryId,
              })),
              loading,
            });
          } else {
            return null;
          }
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
